import { Component, OnInit, OnDestroy, Input, ViewChild, } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import { Subscription } from 'rxjs';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
})
export class FeaturesComponent implements OnInit, OnDestroy {
  private _subscription: Subscription = new Subscription();
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  @Input() data: any;
  @Input() dataCat: any;
  @Input() dataFeatures: any;
  @Input() type: string;
  dataObject: any = [];
  mydata: any = [];
  typeProd: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _store: Store<AppState>,) { }

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el
   * -------------------------------------------------------
   */
  ngOnInit(): void {
    this.setSubscriptions();
  }

  /**
   * -------------------------------------------------------
   * @summary carouselCatalogConfig
   * @description Configuracion del carousel
   * -------------------------------------------------------
   */
  carouselCatalogConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    cssEase: 'linear',
    fade: false,
    autoplay: false,
    autoplaySpeed: 3000,
    draggable: true,
    // responsive: [
    //   {
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 3,
    //     }
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 2,
    //     }
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //     }
    //   }
    // ]
  };

  /**
   * -------------------------------------------------------
   * @summary next
   * @description Boton Next Slide Carousel
   * -------------------------------------------------------
   */
  next() {
    this.slickModal.slickNext();
  }

  /**
   * -------------------------------------------------------
   * @summary prev
   * @description Boton Prev Slide Carousel
   * -------------------------------------------------------
   */
  prev() {
    this.slickModal.slickPrev();
  }

  /**
   * -------------------------------------------------------
   * @summary setSubscriptions
   * @description Traer el valor del state del estado del translated de redux
   * -------------------------------------------------------
   */
  setSubscriptions() {
    this._subscription.add(
      this._store.select('layout').subscribe((state) => {
        if (this.type === 'catalogs') {
          this.getProductName();
        }
      })
    );
  }

  /**
   * -------------------------------------------------------
   * @summary fillColorProd
   * @description Llena los cards de los accesos a categorias
   * de productos con los registtrados en el sisitema
   * -------------------------------------------------------
   */
  // fillColorProd() {
  //   if (this.type === 'products' || this.type === 'products_links') {
  //     let ele = document.getElementsByClassName('bgsigmaprod');
  //     setTimeout(() => {
  //       if (ele.length > 0) {
  //         for (let index = 0; index < ele[0].children.length; index++) {
  //           let numberColor =
  //             this.data[0].features[index].background.split('-')[1];
  //           if (numberColor !== undefined) {
  //             ele[0].children[index].classList.add(
  //               'bgsigmaprod-' + numberColor
  //             );
  //           }
  //         }
  //       }
  //     }, 5);
  //   }
  // }


  /**
   * -------------------------------------------------------
   * @summary getProductName
   * @description  Obtiene el nombre del producto desde la url y asigna nombre del color
   * -------------------------------------------------------
   */
  getProductName() {
    this._activatedRoute.params.subscribe((params) => {
      this.typeProd = params['detail'];
      switch (this.typeProd) {
        case 'treatment-fluids':
          this.asignColorProduct('bgsigmaprodcat-100');
          break;
        case 'wire-lighting':
          this.asignColorProduct('bgsigmaprodcat-200');
          break;
        case 'heavy-machinery':
          this.asignColorProduct('bgsigmaprodcat-300');
          break;
        case 'generation-power':
          this.asignColorProduct('bgsigmaprodcat-400');
          break;
        case 'tools-equipment':
          this.asignColorProduct('bgsigmaprodcat-500');
          break;
        default:
          this.asignColorProduct('bg-gray-500');
          break;
      }
      // return this.colorProd;
    });
  }

  /**
   * -------------------------------------------------------
   * @summary asignColorProduct
   * @description Llena los cards de cada categoria de porducto con el parametro recibido desde redux
   * -------------------------------------------------------
   */
  asignColorProduct(color: string) {
    if (this.type === 'catalogs' && this.dataCat !== undefined) {
      if (color !== undefined) {
        let elecat = document.getElementsByClassName('bgsigmaprodcat');
        if (elecat.length > 0) {
          for (let index = 0; index < elecat[0].children.length; index++) {
            elecat[0].children[index].classList.add(color);
          }
        }
      }
    }
  }

  /**
   * -------------------------------------------------------
   * @summary ngOnDestroy
   * @description  Destruye conexiones abiertas
   * -------------------------------------------------------
   */
  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
